import React from 'react'

import { ScoreRingValue, ScoreRingWrapper } from './ScoreRing.styled'

interface IProps {
  score: number | null | undefined
}

const ScoreRing: React.FC<IProps> = ({ score }) => (
  <ScoreRingWrapper aria-label={`Score ${score ?? 0}`}>
    <ScoreRingValue>{score ?? '—'}</ScoreRingValue>
  </ScoreRingWrapper>
)

export { ScoreRing }
export default ScoreRing
